module.exports = __webpack_public_path__ + "img/ecosystem_cloud_left.5fc1319f.png";